<template>
    <div>
<!--body content start-->



<!--body content start-->

<div id="main-page" class="page-content">

<!--blog start-->

<section>
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="post">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/01.jpg" alt="">
          </div>
          <div class="post-desc pl-0">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h2>These guide Designing work</h2>
            </div>
          </div>
        </div>
        <div>
          <p>Agencio discovering the source behind the filler In seeing a sample, you diminish the importance of the copy by lowering it to the same level as any other visual element. The text simply becomes another supporting role, serving to make other aspects more aesthetic. Instead of your design enhancing the meaning of the content, your content is enhancing</p>
          <p class="ml-5 text-black">Nemo enim ipsam voluptatem, quia voluptas sit, aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos, qui ratione voluptatem sequi nesciunt, neque porro quisquam est, qui dolorem ipsum, quia dolor sit amet consectetur adipisci[ng] velit, sed quia non numquam [do] eius modi tempora inci[di]dunt, The text simply becomes another supporting role, serving to make other aspects more aesthetic Instead of your design</p>
          <p>Agencio discovering the source behind the filler In seeing a sample, you diminish the importance of the copy by lowering it to the same level as any other visual element. The text simply becomes another supporting role, serving to make other aspects more aesthetic. Instead of your design enhancing the meaning of the content, your content is enhancing</p>
        </div>
        <div class="post-tags">
          <ul class="list-inline">
            <li><a href="#">Agency</a>
            </li>
            <li><a href="#">Portfolio</a>
            </li>
            <li><a href="#">Creative</a>
            </li>
          </ul>
        </div>
        <div class="p-4 my-5 box-shadow" data-bg-color="rgba(244,77,133,0.050)">
          <div class="owl-carousel no-pb" data-dots="false" data-items="2" data-md-items="1" data-sm-items="1" data-margin="30" data-autoplay="true">
            <div class="item">
              <div class="row no-gutters post style-2">
                <div class="col-sm-6">
                  <div class="post-image h-100" data-bg-img="images/blog/01.jpg"></div>
                </div>
                <div class="col-sm-6">
                  <div class="post-desc">
                    <div class="post-meta">
                      <ul class="list-inline">
                        <li><a href="#">Admin</a>
                        </li>
                        <li>February 08, 2020</li>
                      </ul>
                    </div>
                    <div class="post-title">
                      <h5>We Develop Digital Strategy</h5>
                    </div> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="row no-gutters post style-2">
                <div class="col-sm-6">
                  <div class="post-image h-100" data-bg-img="images/blog/02.jpg"></div>
                </div>
                <div class="col-sm-6">
                  <div class="post-desc">
                    <div class="post-meta">
                      <ul class="list-inline">
                        <li><a href="#">Admin</a>
                        </li>
                        <li>February 08, 2020</li>
                      </ul>
                    </div>
                    <div class="post-title">
                      <h5>These guide Designing work</h5>
                    </div> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="row no-gutters post style-2">
                <div class="col-sm-6">
                  <div class="post-image h-100" data-bg-img="images/blog/03.jpg"></div>
                </div>
                <div class="col-sm-6">
                  <div class="post-desc">
                    <div class="post-meta">
                      <ul class="list-inline">
                        <li><a href="#">Admin</a>
                        </li>
                        <li>February 08, 2020</li>
                      </ul>
                    </div>
                    <div class="post-title">
                      <h5>We Nominated To Agency</h5>
                    </div> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="media-holder">
          <h3 class="title mb-5">All Comments</h3>
          <div class="media mb-5">
            <img class="img-fluid box-shadow ml-4" alt="image" src="images/thumbnail/01.jpg">
            <div class="media-body d-lg-flex align-items-center">
              <div class="media-user">
                <h6>Charlote Kerry</h6>  <span class="comment-date">08 January, 2020</span> 
              </div>
              <div class="media-comment">
                <p>It's ironic that when the then-understood Latin was scrambled, it became as incomprehensible as Greek; the phrase 'it's Greek to me' and 'greeking' have common semantic roots!</p> <a href="#" class="comment-reply">Reply</a>
              </div>
            </div>
          </div>
          <div class="media mb-5">
            <img class="img-fluid box-shadow ml-4" alt="image" src="images/thumbnail/02.jpg">
            <div class="media-body d-lg-flex align-items-center">
              <div class="media-user">
                <h6>Jesson Mart</h6>  <span class="comment-date">08 January, 2020</span> 
              </div>
              <div class="media-comment">
                <p>May a cusstums offficer somewon nothing of a poison-filled. Until, from a twho, twho chaffinch may also pursue it, not even a lump. But as twho, as a tank</p> <a href="#" class="comment-reply">Reply</a>
              </div>
            </div>
          </div>
          <div class="media mb-5">
            <img class="img-fluid box-shadow ml-4" alt="image" src="images/thumbnail/03.jpg">
            <div class="media-body d-lg-flex align-items-center">
              <div class="media-user">
                <h6>Miraul Avek</h6>  <span class="comment-date">08 January, 2020</span> 
              </div>
              <div class="media-comment">
                <p>For specific projects, collaboration between copywriters and designers may be best, however, like Karen McGrane said, draft copy has a way of turning</p> <a href="#" class="comment-reply">Reply</a>
              </div>
            </div>
          </div>
        </div>
        <div class="post-comments mt-5 theme-bg p-5">
          <div class="section-title">
            <h2 class="title">Leave A Comment</h2>
          </div>
          <form id="contact-form" method="post" action="http://themeht.com/agencio/rtl/contact.php">
            <div id="formmessage"></div>
            <div class="row">
              <div class="form-group col-md-4">
                <input id="form_name" type="text" name="name" class="form-control" placeholder="Name" required="required" data-error="Name is required.">
                <div class="help-block with-errors"></div>
              </div>
              <div class="form-group col-md-4">
                <input id="form_email" type="email" name="email" class="form-control" placeholder="Email" required="required" data-error="Valid email is required.">
                <div class="help-block with-errors"></div>
              </div>
              <div class="form-group col-md-4">
                <input id="form_subject" type="text" name="subject" class="form-control" placeholder="Subject" required="required" data-error="Subject is required.">
                <div class="help-block with-errors"></div>
              </div>
              <div class="form-group mb-0 col-md-12">
                <textarea id="form_message" name="message" class="form-control h-100" placeholder="Your Comment" rows="4" required="required" data-error="Please,leave us a message."></textarea>
                <div class="help-block with-errors"></div>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col">
                <button class="btn btn-white"><span>Post Comment <i class="fas fa-long-arrow-alt-right ml-2"></i></span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>

<!--blog end-->

</div>

<!--body content end--> 

    </div>
</template>

<script>

export default {
    data: function () {
        return {
            name: 'blog single'
        }
    },

};
</script>
